<div class="content">
  <div class="title-container">
    <h1>{{randomQuote}}</h1>
    <p>Das hast du heute erreicht</p>
  </div>
  <div class="count-container">
    <span class="total-count" [class.growing]="animationGrowing">{{animatedTotal}}</span>
    <span>Lernkarten gelernt</span>
  </div>

  <div class="buttons-container">
    <app-button *ngIf="learnsetHasMoreCards" [text]="'Weiterlernen'" (clickEvent)="continueSessionClick()"></app-button>
    <app-button [text]="'Lernsession beenden'" [style]="learnsetHasMoreCards ? 'outlined' : 'filled'" (clickEvent)="finisheSessionClick()"></app-button>
  </div>
</div>